import { INVOICE_STATUS_DATA } from '../actions/actionType'

const initialState = {
  statusList: [],
}
export default function InvoiceStatusReducer(state = initialState, action) {
  switch (action.type) {
    case INVOICE_STATUS_DATA:
      return { ...state, statusList: action.payload }
    default:
      return state
  }
}
